import { createSelector } from 'reselect';
import BagUsageColumns from '../../containers/BagUsageColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.BAG_USAGE_950.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.BAG_USAGE_950.isLoading;

export const getData =
  ReportDefinitions.BAG_USAGE_950.getDataFunction();

export const getColumns =
  createSelector(getData, BagUsageColumns);
